import clsx from 'clsx/lite';
import UpdateBillingAddress from 'components/UpdateBillingAddress/UpdateBillingAddress';
import EnumPermissions from 'hooks/User/enumPermissions';
import useUserInfo from 'hooks/User/useUserInfo';
import { type FC } from 'react';
import styles from './Settings.module.css';

interface SettingsViewProps {
  className?: string;
  updateBillingAddress: (updatedAddress: any) => any;
  billingAddress: any;
  isBillingAddressSet: boolean;
}

const SettingsView: FC<SettingsViewProps> = ({
  updateBillingAddress,
  billingAddress,
  isBillingAddressSet,
  className,
}) => {
  const { permissions } = useUserInfo();

  const hasBillingPermissions = permissions?.includes(EnumPermissions.BILLING) ?? false;
  const hasBillingVisible = permissions?.includes(EnumPermissions.BILLING_VISIBLE) ?? false;
  return (
    <div className={clsx(styles.wrapper, className)}>
      {hasBillingVisible && (
        <UpdateBillingAddress
          updateBillingAddress={updateBillingAddress}
          existingAddress={billingAddress}
          hasAddress={isBillingAddressSet}
          readOnly={!hasBillingPermissions}
        />
      )}
    </div>
  );
};

export default SettingsView;
